import breakpointHelper from "breakpoint-helper";

export const bph = breakpointHelper({
  lg: "1024px",
  md: "840px",
  "2xl": "1440px",
});

export const { listen, listenAll, isMatching, getBreakpoints } = bph;
